module.exports = __webpack_public_path__ + "assets/b120.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b120.png
// module id = 593
// module chunks = 0